'use strict';

import template from '../../templates/settings/Layout.ejs';
import CompanySetupView from './CompanySetup';
import TaxSettingsView from './TaxSettings.js';
import PositionView from './Position.js';
import PayrollItemsView from './PayrollItems.js';
import PaymentView from './PaymentLayout.js';
import LeaveView from './Leave.js';
import NotificationsView from './Notifications.js';
import SubscriptionView from './Subscription.js';
import tooltip from 'helpers/tooltip';
import IntegrationsView from './Integrations.js';

module.exports = Backbone.View.extend({
    contentView: null,

    initialize: function(options) {
        //FIXME NEVER extend this with options
        _.extend(this, options);
    },

    render: function() {
        this.$el.html(template({tab: this.tab}));

        return this;
    },

    // this is only to provide immediate feedback so user quickly sees selected
    // tab
    renderTab: function(tab) {
        this.tab = tab;
        this.render();
    },

    renderContent: function(options) {
        this.render();
        if (this.contentView) {
            this.contentView.remove();
        }

        if (this.tab === 'company') {
            this.contentView = new CompanySetupView(
                _.extend({el: this.$('.js-company-setup')}, options)
            );
            this.$('.js-company-setup-tab').addClass('active');
        } else if (this.tab === 'tax') {
            this.contentView = new TaxSettingsView(
                _.extend({el: this.$('.js-tax')}, options)
            );
            this.$('.js-tax-tab').addClass('active');
        } else if (this.tab === 'positions') {
            this.contentView = new PositionView(
                _.extend({el: this.$('.js-position')}, options)
            );
            this.$('.js-position-tab').addClass('active');
        } else if (this.tab === 'payrollItems') {
            this.contentView = new PayrollItemsView(
                _.extend({el: this.$('.js-payroll-items')}, options)
            );
            this.$('.js-payroll-items-tab').addClass('active');
        } else if (this.tab === 'leave') {
            this.contentView = new LeaveView(
                _.extend({el: this.$('.js-leave')}, options)
            );
            this.$('.js-leave-tab').addClass('active');
        } else if (this.tab === 'payment') {
            this.contentView = new PaymentView(
                _.extend({el: this.$('.js-payment')}, options)
            );
            this.$('.js-payment-tab').addClass('active');
        } else if (this.tab === 'notifications') {
            this.contentView = new NotificationsView(
                _.extend({el: this.$('.js-notifications')}, options)
            );
            this.$('.js-notifications-tab').addClass('active');
        } else if (this.tab === 'subscription') {
            this.contentView = new SubscriptionView(
                _.extend({el: this.$('.js-subscription')}, options)
            );
            this.$('.js-subscription-tab').addClass('active');
        } else if (this.tab === 'integrations') {
            this.contentView = new IntegrationsView(
                _.extend({el: this.$('.js-integrations')}, options)
            );
            this.$('.js-integrations-tab').addClass('active');
        }

        this.$('input[type="checkbox"]').iCheck({
            checkboxClass: 'icheckbox_square-blue'
        });
        tooltip.init(this);
    },

    hideLoader: function() {
        this.$('.js-loading-tab').removeClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Layout.js